import api from './api';

export interface Departamento {
  id: string;
  nome: string;
  descricao: string;
  usuarioResponsavelId?: string;
  nomeUsuario: string;
  areaId?: string;
  areaNome: string;
  sigla: string;
  userName: string;
  diretoriaId?: string;
}

export interface StatusDepartamento {
  valid: boolean;
}

export const getAllDepartamento = () => api.get<Departamento[]>('departamentos');
export const getAllDepartamentoProAreaId = (areaId: string) =>
  api.get<Departamento[]>(`departamentos/getAllDepartamentoProAreaId/${areaId}`);

export const createDepartamento = (departamento: Departamento) => {
  return api.post<Departamento>('departamentos', departamento);
};
export const updateDepartamento = (departamento: Departamento) =>
  api.put<Departamento>(`departamentos/${departamento.id}`, departamento);

export const deleteDepartamento = (id: string) => api.delete<StatusDepartamento>(`departamentos/${id}`);

export const getAllDepartamentoOptions = () =>
  getAllDepartamento().then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const getAllDepartamentoProAreaIdOptions = (areaId: string) => getAllDepartamentoProAreaId(areaId).then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));
